module.exports = __webpack_public_path__ + "img/lksl.c94f08a8.png";